export const CoursesLoadingSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {[1, 2].map((item) => (
        <div
          key={item}
          className="rounded-3xl bg-card border border-border overflow-hidden animate-pulse"
        >
          {/* Image placeholder */}
          <div className="h-40 bg-muted" />

          {/* Avatar and title section */}
          <div className="px-6 -mt-16 relative">
            <div className="flex items-end gap-4">
              <div className="w-32 h-32 rounded-2xl bg-muted border-2 border-card shrink-0" />
              <div className="flex-1 pb-2 space-y-2">
                <div className="w-3/4 h-6 bg-muted rounded" />
                <div className="w-1/2 h-4 bg-muted rounded" />
              </div>
            </div>
          </div>

          {/* Content section */}
          <div className="px-6 pb-6 pt-4">
            <div className="space-y-2 mb-6">
              <div className="w-full h-4 bg-muted rounded" />
              <div className="w-full h-4 bg-muted rounded" />
              <div className="w-2/3 h-4 bg-muted rounded" />
            </div>

            {/* Info section */}
            <div className="p-4 rounded-2xl bg-muted/30 border border-border/50 space-y-3 mb-6">
              <div className="w-32 h-4 bg-muted rounded" />
              <div className="w-40 h-4 bg-muted rounded" />
            </div>

            {/* Features */}
            <div className="space-y-2 mb-6">
              <div className="w-3/4 h-4 bg-muted rounded" />
              <div className="w-2/3 h-4 bg-muted rounded" />
              <div className="w-1/2 h-4 bg-muted rounded" />
            </div>

            {/* Button */}
            <div className="w-full h-10 bg-muted rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
};
